import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { AuthenticationService, TestData } from '../services/authentication.service';
import { TestSchedulerService } from '../services/test_scheduler.service';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { QuestionSetService, QuestionSet, collegequestionset } from '../services/questionset.service';
//import { Evaluate, EvaluateCheck } from './evaluate.model';
import { Schedule } from '../scheduletest/scheduletest.model';
import { College_Names, CollegeService, evaluate } from '../services/College_name.service';
import { Year, YearService } from '../services/year.service';
import { EvaluateCheck } from '../evaluate_marks/evaluate.model';


@Component({
  selector: 'app-audio-evaluate',
  templateUrl: './audio-evaluate.component.html',
  styleUrls: ['./audio-evaluate.component.scss']
})
export class AudioEvaluateComponent implements OnInit {

  
  fieldArray: Array<Schedule> = [];
  selectedCategory;
  selectedCategoryindex: string;
  evaluate_details: evaluate = { college_id: '', year_id: '', questionset_id: '' };
  question_set: collegequestionset = { collegeid: '', yearid: '' }
  //fieldArray: Array<Evaluate> = [];
  newAttribute: any = {};
  Question_Category: any;
  result: boolean;
  details: boolean;
  Category;
  Type;
  Complexity;
  complexityId: string;
  fname;
  lname;
  user;
  view: Array<EvaluateCheck> = [];
  selected: boolean = false;
  userAdmin: boolean;
  overall: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  questionset: boolean;
  scheduletest: boolean;
  mobileQuery: MediaQueryList;

  masterSelected: boolean;
  checkedList: any;

  evaluate: boolean;
  all: boolean;
  candidate: boolean;
  private _mobileQueryListener: () => void;


  college_set: College_Names = {
    college_name: ''
  }
  year_set: Year = {
    academic_year: ''
  }

  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };
  college: any;
  selectedindex: any;
  selectedcollegeset: any;
  Year: any;
  collegeid: any;
  questionsetid: any;
  yeardid: any;
  yearid: any;
  selectedquestionset: any;
  Pattern: any;
  selectedyearset: any;
  year_id: any;
  qset: any;
  userEvaluator: boolean;
  constructor(private fb: FormBuilder, private auth: AuthenticationService, private router: Router, private qs: QuestionSetService,
    private fs: CollegeService, private ys: YearService,
    private testschedulerservice: TestSchedulerService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
    this.masterSelected = false;
    this.simpletest();
    //this.evaluation_details();
    // this.mobileQuery = media.matchMedia('(max-width: 600px)');
    // this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    // this.mobileQuery.addListener(this._mobileQueryListener);
    // this.Questionset();
    this.CollegeName();
  }

  ngOnInit() {
    this.getAccess();
    this.getTempRowData();
  }




  getAccess(){
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');


    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }

  simpletest() {
    this.testschedulerservice.test_scheduler(this.test).subscribe(
      (data) => {

        this.user = sessionStorage.getItem('user');
        this.fname = sessionStorage.getItem('fname');

        this.lname = sessionStorage.getItem('lname');


        return this.result;
      },
      err => {
        console.error(err);
      }
    );
  }

  getTempRowData() {
    this.newAttribute = { college_name: '', academic_year: '', questionsetname: '', pattern: '', date: '', start_time: '', end_time: '', paperlist: '', scheduler: '' };

    this.fieldArray.push(this.newAttribute);
  }




  // this.testtakerservice.test_taker(this.test).subscribe(
  //   (data) => {
  //
  //    this.result1 = data.results;
  //
  //

  //   }
  //);



  view_essays() {

    this.router.navigate(['evaluate_audio_view']);
  }



  selectChangeHandler(event: any, i: any) {

    this.selectedindex = i;

    this.selectedquestionset = event.target.value;

    this.questionsetid = this.selectedquestionset;
    this.qs.pattern(this.selectedquestionset).subscribe(
      (data) => {

        this.Pattern = data.results;
        this.fieldArray[i].paperlist = data.results;


        this.questionsetid = this.selectedquestionset
      },
      err => {
        console.error(err);
      }
    );
  }



  checkUncheckAll() {
    for (var i = 0; i < this.view.length; i++) {
      this.view[i].selected = this.masterSelected;
    }

    this.getCheckedItemList();
  }
  isAllSelected() {
    this.masterSelected = this.view.every(function (item: any) {
      return item.selected === true;
    });
    this.getCheckedItemList();
  }
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.view.length; i++) {
      if (this.view[i].selected) {
        this.checkedList.push(this.view[i]);
      }
    }


    if (this.checkedList.length >= 1) {
      this.all = true;
    } else if (this.checkedList.length === 0) {
      this.all = false;
    }
  }

  selectChangeHandler1(event: any, i: any) {

    this.selectedindex = i;

    this.selectedcollegeset = event.target.value;

    this.collegeid = this.selectedcollegeset;
    localStorage.setItem('CollegeId', this.collegeid)
    this.ys.academicyear(this.selectedcollegeset).subscribe(
      (data) => {

        this.Year = data.results;
        this.fieldArray[i].academic_year = data.results;


        this.yearid = this.Year[0].Id
        localStorage.setItem('Yearid', this.yearid)
      },
      err => {
        console.error(err);
      }
    );
  }

  selectChangeHandler2(event: any, i: any) {

    this.selectedindex = i;

    this.selectedyearset = event.target.value;

    this.year_id = this.selectedyearset;
    localStorage.setItem('CollegeId', this.collegeid)
    this.question_set.collegeid = this.collegeid;
    this.question_set.yearid = this.year_id
    this.qs.college_questionset(this.question_set).subscribe(
      (data) => {

        this.result = data.results;
        this.qset = this.result[0].Id;
        localStorage.setItem('qsid', this.qset);
        //this.questionsetid=this.result[0].Id


      },
      err => {
        console.error(err);
      }
    );
  }


  CollegeName() {
    this.fs.College_Name(this.college_set).subscribe(
      (data) => {

        this.college = data.results;


      },
      err => {
        console.error(err);
      }
    );


}
}
